declare let __BUILD_COMMITISH__: string;

import { OnDestroy, Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { bootstrap_theme } from "../../theme";
import { environment } from "../../environments/environment";
import { LoggerService } from "@bfx/logger";
import { ProfilePromiseActionService, ProfileSettingKeys } from "shared/cubiq-services";

const logger = LoggerService.for(__dirname);
const THEME_KEY = ProfileSettingKeys.userThemeSettings;

@Injectable({
  providedIn: "root",
})
export class LoaderService implements OnDestroy {
  public theme: string = "";
  private themeSubscription: Subscription;

  constructor(private _profileActionService: ProfilePromiseActionService) {
    this.subscribeToTheme();
  }

  subscribeToTheme() {
    this.themeSubscription = this._profileActionService
      .getProfileConfigUpdates(THEME_KEY)
      .subscribe((cssTheme) => {
        this.setCssTheme(cssTheme);
      });
  }

  ngOnDestroy() {
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
  }

  public setCssTheme(name) {
    let themeElement = document.getElementById("theme-id");

    if (name == themeElement.dataset.name) {
      return;
    }

    if (environment.hmr) {
      // no-op hmr builds specific theme
      logger.out.info(`${this.constructor.name}.setCssTheme no-op for HMR`);
    } else if (name == "classic") {
      bootstrap_theme(themeElement, name, `theme-classic.${__BUILD_COMMITISH__}.css`);
      logger.out.info(`${this.constructor.name}.setCssTheme ${name}`);
    } else if (name == "dark") {
      bootstrap_theme(themeElement, name, `theme-default.${__BUILD_COMMITISH__}.css`);
      logger.out.info(`${this.constructor.name}.setCssTheme ${name}`);
    } else {
      bootstrap_theme(themeElement, "dark", `theme-default.${__BUILD_COMMITISH__}.css`);
      logger.out.info(`${this.constructor.name}.setCssTheme default as ${name} not recognized`);
    }
  }
}
